import React, { useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAPICall } from '../../hooks/useAPICall';
import { useEffect } from 'react';

import '../../css/main.css';

export function ResetPasswordForm() {
  

  
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const { MakeCall } = useAPICall();
  let firstRun = useRef(true);
  let resetCode = useRef('');


function handleResetComplete(data)
{
  if (data.components['result'].succeeded === true) {
    document.getElementById("userdetails").style.display = 'none';
    document.getElementById("resulttext").style.display = 'block';
  }
}

function handleRequestReset()
{
    let password = document.getElementById("password").value;
    let confirmPassword = document.getElementById("confirmpassword").value;
    
    MakeCall('member/resetpassword', "{ \"code\" : \"" + resetCode.current + 
    "\", \"password\" : \"" + password + "\", \"confirm\" : \"" + confirmPassword + "\" }", handleResetComplete, true);
    
}
useEffect(() => {
if(firstRun.current)
{
  firstRun.current = false;
  resetCode.current =searchParams.get("code");
  //setResetCode(searchParams.get("code"));  
}

}, [resetCode, searchParams]);

  return (
    <>
      <div className='loginwindow'>
        <div className='loginform' id='userdetails'>
          <div className='titlediv'>PRC Membership Password Reset</div>
          <div style={{width: "100%"}}>
            <div>
                Please enter your new password. It must be at least 8 characters long and contain upper and lower characters
            </div>
            <div className='labeldiv'>
              <label>Password</label>
            </div>
            <div>
              <input className='logininput' placeholder='password' id='password' type='password'></input>
            </div>    
            <div className='labeldiv'>
              <label>Confrim Password</label>
            </div>       
            <div>
              <input className='logininput' placeholder='confirmpassword' id='confirmpassword' type='password'></input>
            </div>
            <div className='buttondiv' style={{paddingTop : "25px"}}>
              <button className='prcbtn' type='button' onClick={handleRequestReset}>Change Password</button>
            </div>
          </div>
        </div>
        <div className='loginform' id='resulttext' style={{"display":"none"}}>
            <p>Your password has been reset, please log in using your new password</p>         
            <div className='buttondiv' style={{paddingTop : "25px"}}>
              <button className='prcbtn' type='button' onClick={()=>{navigate("/Login")}}>Login</button>
            </div>  
        </div>
      </div>
      </>

  );
}


